import { useUserStore } from "~/stores/userStore"

export default defineNuxtRouteMiddleware((_to, _from) => {
  const userStore = useUserStore()
  if (!userStore?.current?.has_thematic_plans) {
    return navigateTo("/")
  }
})
